import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Stack,
} from '@chakra-ui/react';
import Picker1 from '../../../../../../core/components/pickers/Picker1';
import AlertTextSettings from '../atoms/AlertTextSettings';
import {
  ValidationInvalidInputAlert,
  ValidationRuleSettings,
} from '../../../../../../sheet/types';
import { UpdateSettings } from '../useCreateDataValidation';
import Accordion1 from '../../../../../../core/components/accordion/Accordion1';

interface ValidationConfigProps {
  settings: Partial<ValidationRuleSettings>;
  updateSettings: UpdateSettings;
}
const ValidationSettings = ({
  settings,
  updateSettings,
}: ValidationConfigProps) => {
  const alertOptions = Object.values(ValidationInvalidInputAlert);
  const alertType = settings.invalidAlert ?? ValidationInvalidInputAlert.Reject;

  // #region views
  const renderAlertDropdown = () => (
    <Picker1.Menu>
      <Picker1.MenuButton
        title={alertType}
        bg="Background"
        isDisabled={!settings.showAlertWhenInvalid}
      />
      <Picker1.MenuList
        selectedValue={alertType}
        options={alertOptions}
        changeValue={(invalidAlert) => updateSettings({ invalidAlert })}
      />
    </Picker1.Menu>
  );

  const renderHelpTextView = () => (
    <AlertTextSettings
      settings={settings}
      configKey="helpText"
      updateSettings={updateSettings}
    />
  );

  const renderAlertView = () => (
    <Flex justifyContent="space-between">
      <Flex flex="80%" pr="1px">
        <AlertTextSettings
          settings={settings}
          configKey="invalidMessage"
          updateSettings={updateSettings}
        />
      </Flex>
      <Flex flex="20%" pl="1px">
        {renderAlertDropdown()}
      </Flex>
    </Flex>
  );
  //   #endregion

  return (
    <Accordion1
      Header={
        <Box as="span" flex="1" textAlign="left">
          Settings
        </Box>
      }
      Panel={
        <Stack spacing="2">
          {renderHelpTextView()}
          {renderAlertView()}
        </Stack>
      }
    />
  );

  // return (
  //   <Accordion rounded="2xl" allowToggle>
  //     <AccordionItem
  //       rounded="2xl"
  //       border="0px"
  //       background={'ButtonFace'}
  //       overflow="hidden"
  //     >
  //       <AccordionButton>
  //         <Box as="span" flex="1" textAlign="left">
  //           Settings
  //         </Box>
  //         <AccordionIcon />
  //       </AccordionButton>
  //       <AccordionPanel>
  //         <Stack spacing="2">
  //           {renderHelpTextView()}
  //           {renderAlertView()}
  //         </Stack>
  //       </AccordionPanel>
  //     </AccordionItem>
  //   </Accordion>
  // );
};

export default ValidationSettings;
